/**
 * LocationsAtlas: tab toggle. Sets aria-selected on the tab buttons and
 * data-active on both layers. The CSS handles opacity cross-fade and
 * pointer-events on the inactive layer.
 */
(function ($) {
    'use strict';

    $(function () {
        var $section = $('.mnhq-atlas-section');
        if (!$section.length) return;

        var $tabs   = $section.find('.mnhq-atlas-section__tab');
        var $layers = $section.find('.mnhq-atlas__layer');

        $tabs.on('click', function () {
            var $tab    = $(this);
            var target  = $tab.attr('data-target');

            $tabs.removeClass('is-active').attr('aria-selected', 'false');
            $tab.addClass('is-active').attr('aria-selected', 'true');

            $layers.each(function () {
                var $layer = $(this);
                var match  = $layer.attr('data-region') === target;
                $layer.attr('data-active', match ? 'true' : 'false');
                $layer.attr('aria-hidden', match ? 'false' : 'true');
            });
        });
    });
})(jQuery);
